import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getQuickSearchOrders(data) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/order/quicksearch',
        headers: getApiHeader(),
        withCredentials: true,
        data,
    }
    return axios(options)
}

export function getQuickSearchShipment(data) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/shipment/quicksearch',
        headers: getApiHeader(),
        withCredentials: true,
        data,
    }
    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/quickSearch.js